import axios from "axios";

// Ensure BASE_URL is correctly retrieved from environment variables
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchBlogServices = async (page = 1) => {
  try {
    // Retrieve lang value from localStorage
    const lang = localStorage.getItem("lang") || "ru"; // Default to "ru" if not found

    const response = await axios.get(`${BASE_URL}/api/blog?lang=${lang}&limit=8&page=${page}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching blog services:", error);
    throw error;
  }
};
